import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#999",
      "fill-rule": "evenodd",
      d: "M7 14a7 7 0 1 1 7-7 7 7 0 0 1-7 7m1.373-3.466.114-.452a1.8 1.8 0 0 1-.637.146c-.319.012-.377-.036-.466-.106a.48.48 0 0 1-.135-.4 2 2 0 0 1 .041-.343c.028-.15.591-2.151.606-2.313s.023-.274.023-.338a.95.95 0 0 0-.335-.753 1.42 1.42 0 0 0-.953-.29 3.6 3.6 0 0 0-1.532.4l-.113.453a1.9 1.9 0 0 1 .639-.146c.319-.01.377.036.458.11a.52.52 0 0 1 .119.392c0 .105-.629 2.51-.646 2.632a3 3 0 0 0-.025.361.94.94 0 0 0 .344.748 1.44 1.44 0 0 0 .967.295 3.2 3.2 0 0 0 1.531-.396m-.142-5.977A.875.875 0 1 0 7 3.32a.85.85 0 0 0-.258.62.84.84 0 0 0 .258.618.876.876 0 0 0 1.236 0Z"
    }, null, -1)
  ])))
}
export default { render: render }